import { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../login.css";
import logo from "../assetss/kvl17.png";
import bgImage from "../assetss/login-bg.jpg";
import { useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { authLogin } from "../store/slices/auth";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, error, user } = useSelector((state) => state.auth);

  const [showPassword, setShowPassword] = useState(false);

  const [form, setForm] = useState({
    username: "",
    password: "",
  });

  const [errors, setErrors] = useState({});

  const validate = (name, value) => {
    let error = "";

    if (name === "username") {
      if (!value.trim()) error = "Please enter username";
    }

    if (name === "password") {
      if (!value.trim()) error = "Please enter password";
    }

    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm({ ...form, [name]: value });

    const error = validate(name, value);
    setErrors({ ...errors, [name]: error });
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    let newErrors = {};

    Object.keys(form).forEach((key) => {
      const error = validate(key, form[key]);
      if (error) newErrors[key] = error;
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    try {
      const res = await dispatch(authLogin(form)).unwrap();
      console.log(res);

      toast.success("Login successful");
      navigate("/admin/home");
    } catch (err) {
      toast.error(err || "Login failed");
    }
  };

  return (
    <>
      <div
        className="login-page"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          height: "100vh",
        }}
      >
        <Container fluid className="h-100">
          <Row className="h-100 justify-content-center align-items-center">
            <Col xs={11} sm={8} md={6} lg={4}>
              <div className="login-card">
                {/* LOGO */}
                <div className="logo-box text-center">
                  <img src={logo} alt="Logo" className="logo-img" />
                  <h3 className="brand-name">KVL Matrimony</h3>
                </div>

                <h5 className="text-center mb-3">Admin Login</h5>

                <Form onSubmit={handleLogin}>
                  {/* USERNAME */}
                  <Form.Group className="mb-3">
                    <Form.Label style={{ textAlign: "left" }}>
                      Username
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="username"
                      className="input-field"
                      value={form.username}
                      onChange={handleChange}
                      placeholder="Enter username"
                      maxLength={30}
                    />
                    {errors.username && (
                      <small
                        className="text-danger"
                        style={{ textAlign: "left", display: "block" }}
                      >
                        {errors.username}
                      </small>
                    )}
                  </Form.Group>

                  {/* PASSWORD */}
                  <Form.Group className="mb-3">
                    <Form.Label style={{ textAlign: "left" }}>
                      Password
                    </Form.Label>

                    <div className="position-relative">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        placeholder="Enter password"
                        className="input-field"
                        maxLength={10}
                      />

                      <span
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                        }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FaEye /> : <FaEyeSlash />}
                      </span>
                    </div>

                    {errors.password && (
                      <small
                        className="text-danger"
                        style={{ textAlign: "left", display: "block" }}
                      >
                        {errors.password}
                      </small>
                    )}
                  </Form.Group>

                  {/* FORGOT */}
                  {/* <div className="text-end mb-2">
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate("/forgotpassword")}
                    >
                      Forgot password?
                    </span>
                  </div> */}

                  {/* BUTTON */}
                  <Button
                    type="submit"
                    className="w-100 mt-2 login-btn "
                    disabled={loading}
                  >
                    {loading ? "Logging in..." : "Login"}
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Login;
